import { useCallback, useMemo, useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import type { SocialMetricsDataType } from "../../types";

const TABS: SocialMetricsDataType[] = ["comments", "reactions", "shares", "views", "totalPosts", "audienceSize"];

const dataAutomationMap: Record<SocialMetricsDataType, string> = {
    comments: "social-media-metrics-over-time-comments-tab",
    reactions: "social-media-metrics-over-time-reactions-tab",
    shares: "social-media-metrics-over-time-shares-tab",
    views: "social-media-metrics-over-time-views-tab",
    totalPosts: "social-media-metrics-over-time-total-posts-tab",
    audienceSize: "social-media-metrics-over-time-audience-size-tab",
};

const translationKeyMap: Record<SocialMetricsDataType, string> = {
    comments: "activation.alerts.social.metrics.data-type-label.comments",
    reactions: "activation.alerts.social.metrics.data-type-label.reactions",
    shares: "activation.alerts.social.metrics.data-type-label.shares",
    views: "activation.alerts.social.metrics.data-type-label.views",
    totalPosts: "activation.alerts.social.metrics.data-type-label.totalPosts",
    audienceSize: "activation.alerts.social.metrics.data-type-label.audienceSize",
};

export const useTabs = () => {
    const { translate } = useTranslate();
    const [tabIndex, setTabIndex] = useState(0);

    const onSelect = useCallback((index: number) => setTabIndex(index), []);

    const tabs = useMemo(
        () =>
            TABS.map((tab) => ({
                id: tab,
                label: translate(translationKeyMap[tab]),
                dataAutomation: dataAutomationMap[tab],
            })),
        [translate],
    );

    return {
        selectedDataType: TABS[tabIndex],
        tabs,
        tabIndex,
        onSelect,
    };
};
